@import "./shared.css" layer(base);
/* Tailwinds CSS Import */
@import "tailwindcss";
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Oswald:wght@400;500&display=swap")
layer(utilities);

@import "./tailwinds_theme.css" layer(utilities);

/*
  The default border color has changed to `currentColor` in Tailwind CSS v4,
  so we've added these compatibility styles to make sure everything still
  looks the same as it did with Tailwind CSS v3.

  If we ever want to remove these styles, we need to add an explicit border
  color utility to any element that depends on these defaults.
*/
@layer base {
    *,
    ::after,
    ::before,
    ::backdrop,
    ::file-selector-button {
        border-color: var(--color-gray-200, currentColor);
    }
}

body {
    background-color: #222222;
}
a:hover {
    color: #ff9e00 !important;
}

a {
    color: white !important;
}
#map {
    position: fixed;
    width: 46%;
    height: 100vh;
    z-index: 1;
    overflow-y: hidden;
}
.content h1 {
    font-size: 3em;
    color: #fff !important;
    letter-spacing: -1.6px;
    font-weight: 500 !important;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif !important;
    text-shadow: 1px 1px 3px #444;
    margin: auto;
}
.content h2 {
    font-family: "Open Sans", sans-serif;
    font-size: 1.8em;
    color: white;
}
.sidebar .content p {
    font-family: "Open Sans", sans-serif;
    font-size: 1.2rem;
    margin: 1em 2em;
}

.flex-container {
    text-align: center;
    margin: auto;
}

.search-controls {
    position: fixed;
    top: 30%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, 0);

    text-align: center;
    width: 90%;
}
.popup {
    text-align: center;
    font-family: "Oswald", sans-serif !important;
}
.popup h1 {
    font-family: "Oswald", sans-serif !important;
    font-size: 1.3em !important;
}
.popup button {
    margin: auto;
    font-family: "Oswald", sans-serif !important;
    font-size: 1.1em !important;
}
.logo {
    width: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
}

.divider {
    margin: 0.2em 0 0.4em 0;
    height: 1px;
    background-color: rgb(221, 221, 221);
}
#companySearchResultsContainer {
    z-index: 500;
    background: #222222;
    max-height: 200px;
    overflow-y: auto;
    position: absolute;
    border: 1px solid #ff9e00;
    width: 100%;
}
.companySearchResult {
    margin: 0.5em 1em;
    transition: all 0.3s ease-in-out;
}
.companySearchResult:hover {
    transform: scale(1.05);
}
.companySearchResult p {
    color: #7f8a95;
    font-size: 0.8rem;
    text-overflow: ellipsis;
}

.companySearchResultCreate {
    transition: all 0.3s ease-in-out;
    color: #ff9e00 !important;
    margin: 1em;
}
.companySearchResultCreate:hover {
    color: #fff !important;
    transform: scale(1.05);
}
.primaryContainer {
    display: flex;
    height: 100vh;
    background-image: url("https://uploads-ssl.webflow.com/622b5a82e69caa1a56db245e/625c527dc827f527fada78c2_PLOT%20Construction%20Communications%20background%20.jpeg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    font-family: "Open Sans", sans-serif;
}

.item {
    flex: 1.2 1 0;
    display: flex;
    background-color: #222222;
    color: white;
}
.sidebar {
    text-align: center;
    flex: 1 1 0;
    display: flex;
}

.content {
    display: flex;
    flex-wrap: wrap;
    color: white;
    margin: auto;
    width: 100%;
    justify-content: center;
}

.steps {
    display: flex;
    padding: 1rem;
    margin: auto 1rem;
}
.steps-content {
    display: flex;
    flex-basis: 50%;
    padding: 1rem;
    width: 50%;
}
.steps-content h2 {
    font-size: 2em;
    font-family: "Oswald", sans-serif;
    font-style: normal;
    font-weight: 500;
    color: #d8d8d8;
    text-transform: uppercase;
}

.steps-action {
    display: inline-flex;
    flex-direction: row;
    padding: 1rem;
    flex-basis: 100%;
    margin: auto;
    justify-content: center;
}
.steps-back-button {
    cursor: pointer;
    background: none;
    border: none;
}
.steps-back-button:hover {
    transform: scale(1.5);
    transition: all ease 0.5s;
    color: #ff9e00;
}

.steps-action button {
    margin: 0.5rem;
}

.headerLogo {
    width: 50%;
    margin-right: auto;
    padding: 2em 0;
}

.logoArea {
    position: absolute;
    left: 0;
    top: 0;
    right: auto;
    bottom: auto;
    margin-top: 2em;
    text-align: left;
}
.plotLogo {
    width: 30%;
    margin-left: auto;
    margin-right: auto;
    padding: 2em;
}
.suggestions {
    background-color: #fff;
    border-radius: 4px;
    left: 0;
    list-style: none;
    margin: 0.2em 0.4em;
    padding: 0;
    width: 100%;
    top: 110%;
    top: calc(100% + 6px);
    z-index: 1000;
    overflow-y: scroll;
    font-size: 0.8em;
}
.suggestions li {
    margin-top: 0.8em;
    color: black;
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
    line-height: 1em;
    padding: 10px;
}
.suggestions li:last-child {
    border-bottom: none;
}
.suggestions li h2 {
    color: rgb(255, 158, 0);
}
.ant-result {
    padding: 1em 1em !important;
}
.ant-form-item-label > label,
.ant-form-small .ant-form-item-label > label,
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: white !important;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: white !important;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: white !important;
    text-decoration: line-through !important;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
    color: white !important;
    text-decoration: line-through !important;
}
.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
    color: white !important;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
    color: rgba(255, 255, 255, 0.3) !important;
}
.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-description {
    color: rgba(255, 255, 255, 0.3) !important;
}

.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: #ff9e00 !important;
}
.ant-steps-item-process .ant-steps-item-icon {
    border-color: #ff9e00 !important;
}
.ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: white !important;
}
.ant-steps-item-finish .ant-steps-item-icon {
    background-color: #ff9e00 !important;
    border-color: #ff9e00 !important;
}
.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #ff9e00 !important;
}
.ant-space-item {
    min-width: 100%;
}
.ant-result-extra > *:last-child {
    margin: auto;
}
.ant-list-item-meta-title,
.ant-list-item-meta-avatar {
    color: white !important;
}
.ant-list-item-meta-description {
    color: #ff9e00 !important;
}
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background-color: #ffe6be;
}
._2Y6QsytFkIen8EZ8qRminO {
    color: white;
}
.confirmForm {
    color: white;
}
.loginOption {
    text-align: center;
    background: linear-gradient(to left, transparent 50%, rgba(255, 255, 255, 0.1) 50%);
    background-size: 200% 100%;
    background-position: right bottom;
    border-left: 1px solid rgba(255, 255, 255, 0.1);
    padding: 1em 0.5em;
    transition: all 0.5s ease;
}
.loginOption:hover {
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.7);
    background-position: left bottom;
}
.loginOption > a {
    color: rgba(255, 255, 255, 0.5) !important;
}
.loginOption > a:hover {
    color: white !important;
}

/* GEOCODER OVERRIDES */
.mapboxgl-ctrl-geocoder {
    background-color: transparent !important;
    border-bottom: 1px solid #7f8a95;
    font-size: 1em !important;
    box-shadow: none !important;
}
#add-team-geocoder-container .mapboxgl-ctrl-geocoder--input {
    color: black !important;
}
#add-team-geocoder-container .mapboxgl-ctrl-geocoder--input:focus {
    color: black !important;
}
.mapboxgl-ctrl-geocoder--input:focus {
    outline: none !important;
    border-bottom: 2px solid #ff9e00;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}
.mapboxgl-ctrl-geocoder .suggestions {
    color: #404040 !important;
}
.mapboxgl-ctrl-geocoder .suggestions {
    background-color: #222222 !important;
}
.mapboxgl-ctrl-geocoder--suggestion-title {
    color: white;
}
.mapboxgl-ctrl-geocoder--suggestion-title:hover {
    color: #ff9e00;
}
.mapboxgl-ctrl-geocoder .suggestions > .active > a,
.mapboxgl-ctrl-geocoder .suggestions > li > a {
    transition: all 0.3s ease-in-out;
}
.mapboxgl-ctrl-geocoder .suggestions > .active > a {
    background-color: #222222 !important;
}

.mapboxgl-ctrl-geocoder .suggestions > li > a:hover {
    background-color: #222222 !important;
    transform: scale(1.05);
}
.suggestions li {
    margin-top: 0px !important;
    padding: 0px !important;
}
.mapboxgl-ctrl-geocoder .suggestions > li > a {
    color: #404040 !important;
    padding: 0px 0.5em;
}
.mapboxgl-ctrl-geocoder--button {
    background: transparent !important;
}
.mapboxgl-ctrl-geocoder--suggestion-title {
    font-weight: bolder;
}
.mapboxgl-ctrl-geocoder--suggestion-address {
    color: #7f8a95;
    margin-bottom: 0;
    font-size: 0.8rem;
}
.mapboxgl-ctrl-geocoder--suggestion {
    padding: 0.5em 0;
}

.ant-result-title {
    font-family: "Oswald", sans-serif !important;
    color: white !important;
}

.ant-result-subtitle {
    color: white !important;
}
@media screen and (min-width: 640px) {
    .mapboxgl-ctrl-geocoder {
        width: 100% !important;
        max-width: 100% !important;
    }
}
@media only screen and (max-width: 992px) {
    .headerLogo {
        width: 30%;
        margin-right: auto;
        padding: 2em 0;
    }
    .content {
        flex-direction: column;
        align-items: center;
    }
}
@media only screen and (max-width: 600px) {
    body {
        background-color: #222222 !important;
    }
    .logoArea {
        position: absolute;
        left: auto;
        top: 0;
        right: 0;
        bottom: auto;
        margin-top: 2em;
        text-align: right;
    }
    .steps {
        display: block;
    }
    .steps-content {
        min-width: 100%;
        flex-basis: 100%;
    }
}
